/* global screen */
import UAParser from 'ua-parser-js'

import * as qs from 'utils/querystring'

export function removeUndefinedProps (obj) {
  const cleanObj = {}
  Object.keys(obj).forEach((key) => {
    if (obj[key] !== undefined) {
      cleanObj[key] = obj[key]
    }
  })
  return cleanObj
}

function userAgentProps () {
  const parser = new UAParser()
  const props = parser.getResult()

  if (!props.device.type) {
    props.device.type = 'desktop'
  }

  return props
}

export function getUtmData (querystring) {
  const queryobject = qs.parse(querystring)

  const result = {}

  Object.keys(queryobject).forEach((key) => {
    const isUtmProp = x => x.toLowerCase().indexOf('utm') === 0
    if (isUtmProp(key)) {
      result[key] = queryobject[key]
    }
  })

  return result
}

export function getGeneralInfo () {
  return {
    sentAt: Date.now(),
    currentUrl: window.location.url,
    referrer: document.referrer,
    screen: {
      height: screen.height,
      width: screen.width
    },
    ...userAgentProps(),
    ...getUtmData(window.location.search)
  }
}



// WEBPACK FOOTER //
// ./src/services/aliada-analytics/utils.js